import { render, staticRenderFns } from "./TestnetAlert.vue?vue&type=template&id=6b0295eb&scoped=true&"
import script from "./TestnetAlert.vue?vue&type=script&lang=ts&"
export * from "./TestnetAlert.vue?vue&type=script&lang=ts&"
import style0 from "./TestnetAlert.vue?vue&type=style&index=0&id=6b0295eb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0295eb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
